import { render, staticRenderFns } from "./setScreen.vue?vue&type=template&id=1db7b2d8&scoped=true&"
import script from "./setScreen.vue?vue&type=script&lang=js&"
export * from "./setScreen.vue?vue&type=script&lang=js&"
import style0 from "./setScreen.vue?vue&type=style&index=0&id=1db7b2d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7b2d8",
  null
  
)

export default component.exports